export type RemoteResultImageSource = 'camera' | 'gallery';

export const resolveRemoteResultAiButtonTextKey = (imageSource: RemoteResultImageSource, key: 'takeImage' | 'retakeImage' | 'forceObis' | 'cancel') => {
    return imageSource === 'gallery' ? `ai.gallery.buttons.${key}` : `ai.buttons.${key}`;
};

export const resolveRemoteResultAiTextKey = (
    imageSource: RemoteResultImageSource,
    group: 'noResultDialogDetails' | 'invalidMediumOutcome' | 'invalidMeterNumberOutcome' | 'invalidObisOutcome',
    key: 'title' | 'description' | 'expectedLabel' | 'detectedLabel' | 'hint' | 'imageLabel',
) => {
    return imageSource === 'gallery' ? `ai.gallery.${group}.${key}` : `ai.${group}.${key}`;
};
